import { render } from "./SettingsComponent.vue?vue&type=template&id=3e393dbc&ts=true&lang=pug"
import script from "./SettingsComponent.vue?vue&type=script&lang=ts"
export * from "./SettingsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__